import { Callable } from '@prophecy/interfaces/generic';

export namespace LSP {
  export enum Notification {
    open = 'open',
    updateExecutableCode = 'updateExecutableCode',
    close = 'close',
    error = 'error',
    propertiesPublishDiagnostics = 'properties/publishDiagnostics',
    logMessage = 'window/logMessage',
    componentsDidOpen = 'components/didOpen',
    componentsDidUpdate = 'components/didUpdate',
    propertiesDidOpen = 'properties/didOpen',
    featuresDidOpen = 'features/didOpen',
    metadataPropertiesDidOpen = 'metadataProperties/didOpen',
    propertiesDidUpdate = 'properties/didUpdate',
    propertiesDidMasterUpdate = 'properties/didMasterUpdate',
    propertiesDidSchemaUpdate = 'properties/didSchemaUpdate',
    metadataDidOpen = 'metadata/didOpen',
    metadataDidUpdate = 'metadata/didUpdate',
    metadataReloadNeeded = 'metadata/reloadNeeded',
    compileProgress = 'compile/progress',
    textDocumentsDidUpdate = 'textDocuments/didUpdate',
    textDocumentsDidOpen = 'textDocuments/didOpen',
    // textDocumentPublishDiagnostics = 'textDocument/publishDiagnostics',
    textDocumentsPublishDiagnostics = 'textDocuments/publishDiagnostics',
    textDocumentsMetadataDidChange = 'textDocumentsMetadata/didUpdate',
    dependencyUpdate = 'dependency/update',
    ping = 'ping',
    pingTimeout = 'pingTimeout',
    // Dependencies
    dependenciesDidResolve = 'dependencies/resolved',
    windowShowMessage = 'window/showMessage',
    // Copilot
    copilotTranscribe = 'copilot/transcribe',

    copilotAgentProgress = 'copilot/agentProgress',
    copilotKinesisEvents = 'copilot/kinesisEvents',

    copilotDocumentProgress = 'copilot/documentProgress',

    // Copilot Project Agent Chat Message API
    copilotAgentChatMessageDidUpdate = 'copilot/chat/didUpdate',
    copilotAgentEvent = 'copilot/chat/event',
    copilotSnapshotConversationLoaded = 'copilot/snapshotConversationLoaded',
    // Locks
    lockUpdate = 'lock/didUpdate',
    lockTakeOverResponse = 'lock/takeoverResponse',
    lockRequestRelease = 'lock/requestRelease',
    // Collaborators
    collaborators = 'users/update',
    // Broadcast Notifications
    broadcastMessageReceived = 'message/didReceive',
    // session
    sessionDidOpen = 'session/didOpen'
  }
  export enum Method {
    initialize = 'initialize',

    textDocumentDidCreate = 'textDocument/didCreate',
    textDocumentDidDelete = 'textDocument/didDelete',
    textDocumentDidMove = 'textDocument/didMove',
    textDocumentDidSwitch = 'textDocument/didSwitch',
    createGem = 'editor/createGem',

    textDocumentDidChange = 'textDocument/didChange',
    textDocumentDidSave = 'textDocument/didSave',
    textDocumentDidCompile = 'textDocument/didCompile',
    textDocumentDidPublish = 'textDocument/didPublish',
    propertiesDidChange = 'properties/didChange',
    propertiesDidPromote = 'properties/didPromote',
    propertiesDidSave = 'properties/didSave',
    propertiesDidReset = 'properties/didReset',
    propertiesDidCancel = 'properties/didCancel',
    propertiesDidAction = 'properties/didAction',
    propertiesDidCompile = 'properties/didCompile',
    copilotDidRemap = 'copilot/didRemap',
    editorLoadView = 'editor/loadView',
    generateCode = 'codegen/generateCode',
    metadataDidReload = 'metadata/didReload',
    metadataGetDatasets = 'metadata/getDatasets',
    generateExpressionSuggestions = 'copilot/getExpression',
    generateGraphSuggestions = 'copilot/getGraph',
    getSuggestionGraphDifference = 'copilot/getGraphDifference',
    generateModificationSuggestions = 'copilot/modifyGraph',
    copilotDescribe = 'copilot/describe',
    getLabelSuggestion = 'copilot/getLabel',
    getScriptSuggestion = 'copilot/getScript',
    getUdf = 'copilot/getUdf',
    getMacro = 'copilot/getMacro',
    getGenericDataTest = 'copilot/getGenericDataTest',
    copilotFix = 'copilot/fix',
    copilotSpecFlowChatHistory = 'copilot/specflowChatHistory',
    getCopilotGraphById = 'copilot/context',
    suggestGemProperties = 'copilot/suggestGemProperties',
    suggestPrompts = 'copilot/suggestPrompts',
    getBusinessRule = 'copilot/getBusinessRule',
    getBusinessRuleChatHistory = 'copilot/getBusinessRuleChatHistory',
    dataExplorerSaveAsGem = 'dataexplorer/saveAsGem',

    pong = 'pong',
    metadataCreateJob = 'metadata/createJob',
    backendLanguageDidChange = 'beLanguage/didChange',

    // Copilot ProjectAgent Chat API
    loadConversation = 'copilot/agent/loadConversation',
    createConversation = 'copilot/agent/createConversation',
    listConversations = 'copilot/agent/listConversations',
    deleteConversation = 'copilot/agent/deleteConversation',
    copilotAgentUndo = 'copilot/agent/undo',
    copilotAgentChat = 'copilot/agent/chat',
    copilotAgentStop = 'copilot/agent/stop',

    //Upload copilot notification send
    copilotAgentFileUploaded = 'copilot/agent/filesUploaded',
    // Locks
    lockRequest = 'lock/didRequest',
    lockRelease = 'lock/didRelease',
    lockTakeOver = 'lock/didTakeover',
    lockTakeOverRespond = 'lock/didRespondTakeover',
    lockOwnerUpdate = 'lock/didUpdateOwner',
    broadcastMessage = 'message/broadcast',
    copilotKinesisChat = 'copilot/kinesis/chat',
    copilotDataExplorerChat = 'copilot/dataExplorer/chat',
    getPipelineGraphs = 'properties/getPipelineGraphs'
  }

  export type Error = {
    message: string;
    data?: string;
    code?: number;
  };

  export type Success = {
    message: string;
    type: string;
  };
  /**
   * Return type of the LSP callback function.
   *
   * **NOTE**: If the function doesn't return success as { message: string; type: string }, skip using this type.
   */
  export type CallbackReturnType = {
    data?: Success;
    error?: Error;
  };
  export type ExtractParams<C> = C extends Callable ? Parameters<C> : [unknown];
  export type ExtractReturnType<C> = C extends Callable ? ReturnType<C> : never;
  /** Resolved (awaited) return type of the inner LSP method callback */
  export type ExtractResolvedReturnType<C> = C extends Callable ? Awaited<ReturnType<C>> : never;
  /** Union of all possible return shapes from the hook's method (readonly, datasetInfo, success). */
  export type MethodReturnType<D, TMethod extends Method = Method> = {
    error: Error | undefined;
    data: D | undefined;
    isLoading: boolean | undefined;
    isError: boolean | undefined;
    type: TMethod;
  };

  export type MethodType<C extends Callable> =
    ReturnType<C> extends Callable
      ? (
          ...args: Parameters<ReturnType<C>>
        ) => Promise<MethodReturnType<ExtractResolvedReturnType<ReturnType<C>>, Method>>
      : never;
}
